//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'loading',
        props: {

        },
        data () {
            return {
                show: true,
                textHan: this.TEXT_HD
            }
        },
        mounted () {
            const that = this
            const time = that.LOADING_TIME ? that.LOADING_TIME : 1500
            setTimeout(function () {
                that.show = false
            }, time)
        }
    }
